/** Klassen samenvoegen; valse waarden vallen weg. */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}
